<template>
  <button
    class="abBtn"
    :class="classes"
  >
    <slot />
  </button>
</template>


<script setup>
const props = defineProps({
	disabled: {
		type: Boolean,
		default: false
	},
	block: {
		type: Boolean,
		default: false
	},
	flex: {
		type: Boolean,
		default: false
	},
	listed: {
		type: Boolean,
		default: false
	},
	textInputHeight: {
		type: Boolean,
		default: false
	},
	blueWhite: {
		type: Boolean,
		default: false
	},
	whiteBlue: {
		type: Boolean,
		default: false
	},
	yellowBlue: {
		type: Boolean,
		default: false
	}
});

const classes = computed(() => {
	return {
		'abBtn--disabled': props.disabled,
		'abBtn--block': props.block,
		'abBtn--flex': props.flex,
		'abBtn--listed': props.listed,
		'abBtn--textInputHeight': props.textInputHeight,
		'abBtn--blueWhite': props.blueWhite,
		'abBtn--whiteBlue': props.whiteBlue,
		'abBtn--yellowBlue': props.yellowBlue
	};
});
</script>

<style lang="scss" scoped>
.abBtn {
	@include resetBtn;

	display: inline-block;
	padding: 0.95rem 1.6rem;
	text-decoration: none;
	outline: none;
	user-select: none;
	border-radius: $borderRadius-md;
	cursor: pointer;

	& > * {
		pointer-events: none;
	}

	&:disabled {
		border-color: $neutral-border-color;
		background-color: $very-disabled-bg;
		color: $white;
	}

	&.abBtn--block {
		display: block;
		width: 100%;
	}

	/// mark 2
	&.abBtn--flex {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1 0 auto;
	}

	&.abBtn--textInputHeight {
		padding: 1.6rem 0;
		font-size: 2rem;
		margin-left: 1rem;
	}

	&.abBtn--blueWhite {
		background-color: $main-btn-bg;
		color: $white;
	}

	&.abBtn--whiteBlue {
		border: 0.1rem solid;
		background-color: $white;
		color: $main-font-color;
	}

	&.abBtn--yellowBlue {
		background-color: $cta-btn-bg;
		color: $main-font-color;
		border-radius: $borderRadius-md;

		&:visited {
			background-color: $cta-btn-bg;
		}

		&:active {
			background-color: $clickout-btn-bg;
		}
	}

	&.abBtn--listed {
		display: block;
		position: relative;
		padding: 1.8rem;
		width: 100%;
		text-align: left;
		font-size: 1.8rem;
		color: $main-font-color;
		border-radius: 0;

		&::before {
			content: '';
			position: absolute;
			bottom: 0;
			width: calc(100% - 3.5rem);
			height: 0.1rem;
			background-color: $very-disabled-bg;
		}

		&:last-child {
			&::before {
				content: none;
			}
		}

		& > span:last-child {
			display: none;
		}

		@media (max-width: 767px) {
			& > span:last-child {
				float: right;
				font-weight: 700;
				padding-top: 0.4rem;
				font-size: 1.8rem;
			}
		}
	}
}
</style>
